import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[wchfsLazyTab]',
})
export class LazyTabDirective {
  constructor(public template: TemplateRef<any>) {}
}
